import React from 'react';

import SideMenu from '../../components/SideMenu';
import Footer from '../../components/Footer';
import QuotesCripto from '../../components/QuotesCripto';
import { getTranslations } from '../../services/languageUtils';
import Table from '../../components/Crypto/Table'; // Asegúrate de que la ruta sea correcta

class Item extends React.Component {
  constructor(props) {
      super(props);

      this.state = {
        type: 'copyAndPaste',
        step: 0,
        translations: {},
        tableData: [
          { asset: 'Bitcoin', price: 27000 },
          { asset: 'Ethereum', price: 1800 },
          { asset: 'Cardano', price: 0.36 },
        ],
      };
  }

  componentDidMount() {
    this.loadTranslations();
  }

  loadTranslations = async () => {
    const translations = await getTranslations((localStorage.getItem('language') || 'pt'));
    this.setState({ translations });
  };

  onChangeValue = event => {
    switch(event.target.name){
      case 'step':
        this.setState({step: event.target.value});
        break;

      default:
        break;
    }
  }

  render() {
    return (
     <section id="userPage" className="userPage transactionPage">
       <SideMenu />
 
       <div className="contentData">
         <div className="contentScroll">
         <QuotesCripto />
         <p className="breadcrumb"><b><span className="textPrimary">{this.state.translations.home} </span> | {this.state.translations.cryptoCurrency}</b></p><br/>
         <p className="title"><span style={{fontWeight: "normal"}}>Home Broker</span> </p><br/>
 
         <div className="contentSubData">
           <Table data={this.state.tableData} translations={this.state.translations} />
         </div>
 
         <Footer />
         </div>
       </div>
     </section>
    );
   }
 }

export default Item;
